import { Radio, RadioList, Text } from "@ucl/react-library";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useBoundInput } from "src/hooks/use-bound-input";
import { ContactPreference } from "src/api/types/enums";

export const ContactPreferenceUpdate = () => {
  const { t } = useTranslation();

  const { control } = useFormContext();
  const contactPreferenceProps = useBoundInput({ name: "preferredContactChannel", control });

  return (
    <div className="flex flex-col gap-5" data-testid="updateContactPreference" >
      <div className="flex flex-col gap-3">
        <Text.P size="large" fontWeight="semi-bold">
          {t("contactInfo.preferenceTitle")}
        </Text.P>
        <Text.P size="large">{t("contactInfo.preferencePara1")}</Text.P>
        <Text.P size="large">{t("contactInfo.preferencePara2")}</Text.P>
      </div>

      <Text.P size="large" fontWeight="semi-bold">
         {t("contactInfo.subHeading")}
      </Text.P>

      <RadioList  {...contactPreferenceProps} helperTextProp={{secondaryProp: {helperText: t("contactInfo.contactPreferenceRequired")}}} >
        <Radio label={t("contactInfo.emailRadio")} value={ContactPreference.Email} data-testid="emailRadio" />
        <Radio label={t("contactInfo.postRadio")} value={ContactPreference.Post} data-testid="postRadio" />
      </RadioList>
    </div>
  );
};